import { ConfirmModal } from '../../components/ConfirmModal';
import { PAUSE_MESSAGE_MAX_LENGTH } from './useOrganizationPause';
import './OrganizationPause.css';

interface PauseOrganizationModalProps {
  isOpen: boolean;
  organizationName: string;
  message: string;
  onMessageChange: (message: string) => void;
  loading: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirms pausing an organization, with an optional custom message for its users. */
export const PauseOrganizationModal = ({
  isOpen,
  organizationName,
  message,
  onMessageChange,
  loading,
  error,
  onConfirm,
  onClose,
}: PauseOrganizationModalProps) => (
  <ConfirmModal
    isOpen={isOpen}
    title="Pause Organization"
    message={`Pause "${organizationName}"? Everyone in this organization will be blocked from RosterPilot until you resume it. You can undo this at any time.`}
    confirmText={loading ? 'Pausing...' : 'Pause'}
    busy={loading}
    onConfirm={onConfirm}
    onClose={onClose}
  >
    <label className="org-pause-form__label" htmlFor="org-pause-message">
      Message shown to users (optional)
    </label>
    {/* The placeholder deliberately does not restate the API's default copy -
        duplicating it here would silently go stale the moment the server's
        default changes. */}
    <textarea
      id="org-pause-message"
      className="org-pause-form__input"
      rows={3}
      maxLength={PAUSE_MESSAGE_MAX_LENGTH}
      placeholder="Leave blank to use the default message"
      value={message}
      onChange={(e) => onMessageChange(e.target.value)}
      disabled={loading}
      data-testid="org-pause-message"
    />
    {/* "Leave blank" guidance lives in the placeholder, which is visible in
        exactly the case it applies to - an empty field. */}
    <div className="org-pause-form__counter">
      {message.length}/{PAUSE_MESSAGE_MAX_LENGTH}
    </div>
    {error && (
      <div className="org-pause-form__error" role="alert" data-testid="org-pause-error">
        {error}
      </div>
    )}
  </ConfirmModal>
);
